import { useState, useEffect, useRef, useCallback} from 'react'
import { getUpcomingAirDates } from '@scrippsproduct/scripps-external-component-library/dist/utils/getUpcomingPrograms'
import { Loading, UpcomingList } from '@scrippsproduct/scripps-external-component-library'
import { determineEpisodeNumber, determineSeasonNumber } from '@scrippsproduct/scripps-external-component-library/dist/utils/series-helpers'
import { convert12to24 } from '@scrippsproduct/scripps-external-component-library/dist/utils/helpers'

const SCHEDULE_ENDPOINT = process.env.REACT_APP_SCHEDULE_V2
const NETWORK = process.env.REACT_APP_NETWORK

function ShowUpcomingWrapper({ seriesPrefix, seriesTitle, handleClicks = () => {} }) {
    const [nextAirDates, setNextAirDates] = useState([])
    const [isFeteched, setIsFetched] = useState(false)
    const seriesTitleRef = useRef(seriesTitle)

    const getPrograms = useCallback(() => {
        ;(async () => {
            const programs = await getUpcomingAirDates({ 
                programId: seriesPrefix, 
                SCHEDULE_ENDPOINT, 
                NETWORK
            })

            const airdates = programs.map(progam => ({
                id: progam.id,
                airdate: `${progam.start_date_parse} ${convert12to24(progam.start_time)}`, 
                title: {
                    synopsis: progam.program_synopsis,
                    image: { 
                        url: progam.content.image,
                    },
                    episode_number: `${determineSeasonNumber(progam)}${determineEpisodeNumber(progam)}`,
                    name: progam.title_name,
                    rating: progam.rating,
                    element_length: progam.element_length,
                },
                program: {
                    title: seriesTitleRef.current,
                },
            }))

            setNextAirDates([...airdates])
            setIsFetched(true)
            
        })()
    }, [seriesPrefix])

    useEffect(() => getPrograms(), [getPrograms])
    
    return  (<>
        <h2 className='h2'>Upcoming Episodes</h2>
        { (nextAirDates.length > 0) 
            ? <UpcomingList list={nextAirDates} handleClicks={handleClicks} /> 
            : (isFeteched) 
                ? <p>This show doesn't have any episodes scheduled in the next two weeks. Please check back to see when it will be airing again.<br></br>Or you can view our <a href="/schedule" className="inline-anchor">full schedule</a> to see what shows are airing.</p> 
                : <Loading /> 
        }
    </>)
}

export default ShowUpcomingWrapper